<div class="container-wrapper">
  <div class="main-wrapper">

    <div class="content-wrapper">

      <div class="faq-section" *ngIf="!showLoader">
        <h2 class="main-heading font-18 font-500">Most Viewed FAQs
          ({{questionCount}})</h2>
        <div class="accordian-wrapper" >
          <ul aria-label="Most viewed FAQs">
            <li *ngFor="let item of finalQuestionArray; index as i">
              <button type="button"
                class="faq-item-btn"
                [attr.id]="'faq-item-' + i"
                [attr.aria-label]="'Read FAQ: ' + item.title"
                (click)="goTosubCategoryAnswers(item.id, item.category.id, item.permalink)">
                <span class="label">{{item.title}}</span>
                <span class="icon-right-chevron" aria-hidden="true"></span>
              </button>
            </li>
          </ul>

          <div class="view-more">
            <button type="button"
              class="fw-500 text-link view-more-btn"
              #viewMoreLink
              [attr.aria-expanded]="viewChange === constantService.viewLess"
              [attr.aria-label]="viewChange === constantService.viewMore ? 'View more frequently asked questions' : 'View less frequently asked questions'"
              (click)="getViewMore(viewChange)">
              {{ viewChange }}
              <span [ngClass]="{
                      'icon-chevron-up': viewChange === 'View Less',
                      'icon-chevron-down': viewChange === 'View More'
                  }" aria-hidden="true"></span>
            </button>
          </div>
        </div>        
      </div>

      <div class="faq-section" *ngIf="showLoader">
        <h3 class="main-heading font-18 font-500"><span class="loading--shimmer w30"></span>
          </h3>
        <div class="accordian-wrapper">
          <ul>
            <li>
              <span class="loading--shimmer w80"></span>
              <span class="loading--shimmer w10"></span>
            </li>
            <li>
              <span class="loading--shimmer w80"></span>
              <span class="loading--shimmer w10"></span>
            </li>
            <li>
              <span class="loading--shimmer w80"></span>
              <span class="loading--shimmer w10"></span>
            </li>
          </ul>

          <div class="view-more">
            <a class="fw-500">
              <span class="loading--shimmer w10"></span>
              <span class="loading--shimmer w10"></span>
            </a>
          </div>

        </div>
      </div>

      <div class="knowledge-base" *ngIf="!showKBloader">
        <h2 class="main-heading">Knowledge Base</h2>
        <div class="row">
          <div class="col-6" *ngFor="let item of mainBaseArray; index as i">
            <div class="card"
              tabindex="0"
              role="button"
              [attr.aria-label]="'Browse ' + item.name + ' knowledge base category'"
              (click)="goToKnowledgeBaseComponent(item.permalink, item.name)"
              (keydown)="onKnowledgeBaseKeydown($event, item.permalink, item.name)">
              <h3>{{ item.name }}</h3>
            </div>
          </div>
        </div>
      </div>

      <div class="knowledge-base" *ngIf="showKBloader">
        <h2 class="main-heading"><span class="loading--shimmer w40"></span></h2>
        <div class="row">
          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>
        </div>
      </div>

      <hr>

      <!-- <div class="create-ticket-wrapper" *ngIf="isLoggedIn == 'Y'"> -->
      <div class="create-ticket-wrapper">
        <h2 role="heading" class="main-heading">Still Stuck?</h2>
        <h3 class="sub-heading">Have you tried looking for an answer?</h3>
        <p>
          Create a ticket and we will respond as soon as possible, or you can
          return later.
        </p>
        <div class="row-wrapper">
          <div class="ticket-button-wrapper">
            <button class="primary-btn" (click)="goToCreateTicket()">Create a Ticket</button>
            <!-- <button class="transparent-btn fw-500">Or contact our support</button> -->
            <button class="transparent-btn fw-500" (click)="letsChat()">or Chat with us</button>
          </div>

          <div class="phone-icon-container">
              <a href="tel:8976689766"
                class="phone-icon"
                aria-label="Call 5paisa support team at 89766 89766. Available Monday to Friday 8:30 AM to 6:00 PM, Saturday 9:30 AM to 3:30 PM"
                (click)="showPhonePopup($event)">
                <img class="" src="https://images.5paisa.com/forum/Call.png" alt="" aria-hidden="true"/>
              </a>
          </div>
        </div> 
      </div>
    </div>
  </div>
</div>

<!-- Custom Phone Call Popup -->
<div class="phone-popup-overlay" *ngIf="showPhoneModal" (click)="closePhonePopup()">
  <div class="phone-popup-content" (click)="$event.stopPropagation()">
    <div class="phone-popup-header">
      <h3 class="phone-popup-title">Reach out 5paisa Support Team</h3>
      <button class="phone-popup-close" (click)="closePhonePopup()">×</button>
    </div>
    
    <div class="phone-popup-body">
      <!-- <div class="phone-number-display"></div> -->
      <p class="phone-popup-message">
        Monday-Friday
        <span style="font-weight: 800;">
          8:30 AM - 6.00 PM 
        </span> 
      </p>

      <p class="phone-popup-message">
        Saturday
        <span style="font-weight: 800;"> 
        9.30 AM - 3.30 PM </span>
      </p>
      <p class="phone-popup-message">
        Mobile Number
        <span class="phone-number-display" style="font-weight: 800;">
         +91 {{phoneNumber}}
        </span> 
      </p>
    </div>
    
    <!-- <div class="phone-popup-buttons">
      <button class="phone-btn phone-btn-call" (click)="makeCall()">Call Now</button>
      <button class="phone-btn phone-btn-cancel" (click)="closePhonePopup()">Cancel</button>

    </div> -->
  </div>
</div>